import * as actionTypes from '../../types/services';
import {
  servicesCategories,
  servicesProviders,
  servicesStartCounts,
  servicesSubscriptionTypes,
  servicesConfiguration,
  servicesTypes,
  servicesStatus,
  servicesMassStatus,
  servicesMassDripFeed,
  serviceServicesMassDelete,
  serviceServicesAssignCategory,
  serviceServicesDelete,
  serviceServicesMassResetCustomRate,
  serviceServicesChangePositionCategory,
  serviceServicesChangePosition,
} from '../../../services/endpoints/services';

/**
 * @function
 * @name getCategoriesList
 * @description Листинг сервисов
 */
export const getCategoriesList = () => async (dispatch) => {
  try {
    const response = await servicesCategories();
    const { data } = response;

    dispatch({
      type: actionTypes.CATEGORIES_LIST_SUCCESS,
      doNotUpdateNavbar: true,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.CATEGORIES_LIST_ERROR, error });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name getProvidersList
 * @description Листинг провайдеров
 */
export const getProvidersList = () => async (dispatch) => {
  try {
    const response = await servicesProviders();
    const { data } = response;
    dispatch({
      type: actionTypes.PROVIDERS_LIST_SUCCESS,
      doNotUpdateNavbar: true,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.PROVIDERS_LIST_ERROR, error });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name getStartCountsList
 * @description Листинг старт каунтов
 */
export const getStartCountsList = () => async (dispatch) => {
  try {
    const response = await servicesStartCounts();
    const { data } = response;
    dispatch({
      type: actionTypes.START_COUNTS_LIST_SUCCESS,
      doNotUpdateNavbar: true,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.START_COUNTS_LIST_ERROR, error });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name getSubscriptionTypesList
 * @description Листинг subscription type
 */
export const getSubscriptionTypesList = () => async (dispatch) => {
  try {
    const response = await servicesSubscriptionTypes();
    const { data } = response;
    dispatch({
      type: actionTypes.SUBSCRIPTION_TYPES_LIST_SUCCESS,
      doNotUpdateNavbar: true,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.SUBSCRIPTION_TYPES_LIST_ERROR, error });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name getServiceTypesList
 * @description Листинг service type
 */
export const getServiceTypesList = () => async (dispatch) => {
  try {
    const response = await servicesTypes();
    const { data } = response;
    dispatch({
      type: actionTypes.SERVICE_TYPE_LIST_SUCCESS,
      doNotUpdateNavbar: true,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.SERVICE_TYPE_LIST_ERROR, error });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name getConfiguration
 * @description Конфигурация для services
 */
export const getConfiguration = () => async (dispatch) => {
  try {
    const response = await servicesConfiguration();
    const { data } = response;
    dispatch({
      type: actionTypes.CONFIGURATION_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.CONFIGURATION_ERROR, error });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesInit
 * @description Запрос всех необходимых листингов (configuration, providers, categories, start counts )
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const servicesInit = () => async (dispatch) => {
  dispatch({ type: actionTypes.INIT });

  try {
    const configuration = await dispatch(getConfiguration());
    const access = configuration?.data?.access;
    const requestPull = [
      dispatch(getCategoriesList()),
      dispatch(getStartCountsList()),
      dispatch(getServiceTypesList()),
    ];
    /**
     * Если add_subscription === false
     * То список Subscription type будет 403
     */
    if (access.add_subscription) {
      requestPull.push(
        dispatch(getSubscriptionTypesList()),
      )
    }
    /**
     * Если see_provider_column и edit_services и import_services
     * будут false
     * То список провайдеров не прийдет
     */
    if (access.see_provider_column || access.edit_services || access.import_services) {
      requestPull.push(
        dispatch(getProvidersList()),
      )
    }
    //      dispatch(getProvidersList()),
    await Promise.all(requestPull)
    return dispatch({ type: actionTypes.INIT_SUCCESS });
  } catch (error) {
    return dispatch({ type: actionTypes.INIT_ERROR });
  }
};

/**
 * @function
 * @name servicesCheckedMassAdd
 * @description Выделить все сервисы
 */
export const servicesCheckedMassAdd = (data) => (dispatch) => dispatch({
  type: actionTypes.SERVICE_CHECKED_MASS_ADD,
  data,
});

/**
 * @function
 * @name servicesCheckedMassRemove
 * @description Снять выделение у всех сервисов
 */
export const servicesCheckedMassRemove = () => (dispatch) => dispatch({
  type: actionTypes.SERVICE_CHECKED_MASS_REMOVE,
});

/**
 * @function
 * @name servicesCheckedSet
 * @description Выделить сервисы
 */
export const servicesCheckedSet = (services) => (dispatch) => dispatch({
  type: actionTypes.SERVICE_CHECKED_SET_STATE,
  services,
});

/**
 * @function
 * @name categoryServicesCheckedAdd
 * @description Выделить все сервисы для категории
 */
export const categoryServicesCheckedAdd = (id) => (dispatch) => dispatch({
  type: actionTypes.CATEGORY_SERVICES_CHECKED_ADD,
  id,
});

/**
 * @function
 * @name categoryServicesCheckedRemove
 * @description Снять выделение у сервисов для категории
 */
export const categoryServicesCheckedRemove = (id) => (dispatch) => dispatch({
  type: actionTypes.CATEGORY_SERVICES_CHECKED_REMOVE,
  id,
});

/**
 * @function
 * @name servicesChangeStatus
 * @param {number} id - id сервиса
 * @param {number} status - 1/0
 * @description Изменить статус сервиса (Enabled/Disabled)
 */
export const servicesChangeStatus = (id, status) => async (dispatch) => {
  try {
    await dispatch({
      type: actionTypes.CHANGE_STATUS,
    });
    const response = await servicesStatus(id, status);
    const { data } = response;
    await dispatch({
      type: actionTypes.CHANGE_STATUS_SUCCESS,
      data,
    });
    await dispatch(getCategoriesList());
    return response;
  } catch (error) {
    dispatch({ type: actionTypes.CHANGE_STATUS_ERROR });
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesMassChangeStatus
 * @param {number} status - 1/0
 * @param {array} list - список ID
 * @description Изменить массово статус сервиса (Enabled/Disabled)
 */
export const servicesMassChangeStatus = (payload) => async (dispatch) => {
  try {
    await servicesMassStatus(payload);
    await dispatch(getCategoriesList());
    return await dispatch({
      type: actionTypes.SERVICES_MASS_CHANGE_STATUS_SUCCESS,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesMassDelete
 * @param {array} list - список ID
 * @description Удалить список ID
 */
export const servicesMassDelete = (list) => async (dispatch) => {
  try {
    await serviceServicesMassDelete(list);
    await dispatch(getCategoriesList());
    return await dispatch({
      type: actionTypes.SERVICES_MASS_DELETE_SUCCESS,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesDelete
 * @param {number} id - список ID
 * @description Удалить сервис
 */
export const servicesDelete = (id) => async (dispatch) => {
  try {
    await serviceServicesDelete(id);
    await dispatch(getCategoriesList());
    return await dispatch({
      type: actionTypes.SERVICE_DELETE,
      id,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesMassAssignCategory
 * @param {number} categoryId - ID категории
 * @param {array} list - список ID
 * @description изменить категорию у списка сервисов
 */
export const servicesMassAssignCategory = (categoryId, list) => async (dispatch) => {
  try {
    await serviceServicesAssignCategory(categoryId, list);
    await dispatch(getCategoriesList());
    return await dispatch({
      type: actionTypes.SERVICES_MASS_ASSIGN_CATEGORY,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesMassResetCustomRates
 * @param {array} list - список ID
 * @description сброс custom rate у списка сервисов
 */
export const servicesMassResetCustomRates = (list) => async (dispatch) => {
  try {
    await serviceServicesMassResetCustomRate(list);
    await dispatch(getCategoriesList());
    return await dispatch({
      type: actionTypes.SERVICES_MASS_RESET_CUSTOM_RATES,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesChangePositionCategory
 * @param {array} list - список новых позиций
 * @description сброс custom rate у списка сервисов
 */
export const servicesChangePositionCategory = (list) => async (dispatch) => {
  try {
    const response = await serviceServicesChangePositionCategory(list);
    if (response?.data) {
      return dispatch({ type: actionTypes.CATEGORY_SORTABLE_SUCCESS, data: response.data })
    }
    return new Error('Not found response data')
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesChangePositionServices
 * @param {number} categoryId - Id категории
 * @param {array} list - список новых позиций
 * @description сброс custom rate у списка сервисов
 */
export const servicesChangePositionServices = (categoryId, list) => async (dispatch) => {
  try {
    const response = await serviceServicesChangePosition(categoryId, list);
    if (response?.data) {
      return dispatch({ type: actionTypes.SERVICES_SORTABLE_SUCCESS, data: response.data })
    }
    return new Error('Not found response data')
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * @function
 * @name servicesMassChangeDripFeed
 * @param {number} drip_feed - 1/0
 * @param {array} list - список ID
 * @description Изменить массово drip-feed (Enabled/Disabled)
 */
export const servicesMassChangeDripFeed = (drip_feed, list) => async (dispatch) => {
  try {
    await servicesMassDripFeed(drip_feed, list);
    await dispatch(getCategoriesList());
    return await dispatch({
      type: actionTypes.SERVICES_MASS_CHANGE_DRIP_FEED_SUCCESS,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};
